export default __webpack_public_path__ + "static/media/background.b5bf14e4.jpg";